import appConstants from "../../../../../../appConstants";
import StaticData from "../common/staticData";
import { COUNTRIES } from "../../constants";

const getDefaultShipmentData = ({
  getProNumber,
  shipment,
  proNumberLength,
}) => {
  const isProPreAssigned =
    shipment?.proId === "0" ? false : Boolean(shipment?.proId);
  return {
    proNumber: getProNumber({
      proNumber: shipment?.proId ?? "",
      isProPreAssigned: isProPreAssigned,
      proNumberLength: proNumberLength
    }),
    isProPreAssigned,
    accessorials: [],
    priority: shipment?.priority ?? "",
    isFood: shipment?.isFood || false,
    isExcessiveLength: shipment?.isExcessiveLength ? appConstants.EXCESSIVE_SHIPMENT.YES : appConstants.EXCESSIVE_SHIPMENT.NO,
    isFreezable: shipment?.isFreezable || false,
    isAmmunition: shipment?.isAmmunition || false,
    isHazmat: shipment?.isHazmat || false,
    excessiveProLength: "",
    consigneeName: shipment?.consigneeName || "",
    consigneeCity: shipment?.consigneeCity || "",
    consigneeCountry: shipment?.consigneeCountry || COUNTRIES.US,
    consigneeZip: shipment?.consigneeZip || "",
    pieces: shipment?.pieces || "",
    weight: shipment?.weight || "",
    packagingItems: [
      { hu: shipment?.hu || "", packageCode: shipment?.packageCode || "" },
    ],
    hazmatInfo: shipment?.hazmatInfo || [],
    comment: shipment?.comment || "",
    consigneeAddress1: shipment?.consigneeAddress1 || "",
    consigneeAddress2: shipment?.consigneeAddress2 || "",
    consigneeCode: shipment?.consigneeCode || "",
    consigneeState: shipment?.consigneeState || "",
    ediProNumber: shipment?.ediProNumber || "",
    limitedAccessCode: shipment?.limitedAccessCode || "",
    receivedCanadianDocumentation:
      shipment?.receivedCanadianDocumentation || false,
    rmaxShipperCode: shipment?.rmaxShipperCode || null,
  };
};

const getDefaultPickupStopInfo = ({getProNumber, stopData, proNumberLength}) => {
  const isStopCompleted = stopData.isStopCompleted;
  return stopData.shipments
    .map((shipment) => {
      const defaultShipmentData = getDefaultShipmentData({
        getProNumber,
        shipment,
        proNumberLength,
      });
      if (shipment.proId) {
        return {
          shipmentId: shipment.shipmentId,
          editInfo: defaultShipmentData,
          errorInfo: {
            packagingItemsErrorInfo: [{ hu: null, packageCode: null }],
          },
          openEditMode: false,
          initialDataExists: true,
          isUpdatedAtLeastOnce: false,
          ...(isStopCompleted && { isCompletedPro: true }),
          pickupStatus: isStopCompleted ? appConstants.PICKUP_STATUS.COMPLETED: appConstants.PICKUP_STATUS.WAITING,
        };
      }
    })
    .filter((data) => data);
};

const getPriorityShipmentList = (priorityShipmentList) => {
  return priorityShipmentList.map((data) => ({
    value: data.value,
    labelText: data.label,
  }));
};

const getExcessiveShipmentList = () => {
  return appConstants.EXCESSIVE_SHIPMENT_OPTIONS.map((data) => ({
    value: data.statusCode,
    labelText: data.status,
  }));
};

const getCountryList = () => {
  return StaticData.countries.map((data) => ({
    value: data.code,
    label: data.name,
  }));
};

export {
  getDefaultPickupStopInfo,
  getDefaultShipmentData,
  getPriorityShipmentList,
  getCountryList,
  getExcessiveShipmentList,
};
